var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:this.$route.name == 'send-shipment' ? 'bg-white' : ''},[_c('app-navbar'),_c('div',{staticClass:"container",staticStyle:{"min-height":"800px"}},[_c('div',[_c('router-view')],1)]),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }